import React, {useRef, useImperativeHandle, forwardRef} from 'react';
import {Turnstile} from '@marsidev/react-turnstile';
import {useTranslation} from 'react-i18next';

export const Captcha = forwardRef(({onVerify}, ref) => {
    const {i18n} = useTranslation();
    const turnstileRef = useRef();

    useImperativeHandle(ref, () => ({
        reset: () => {
            turnstileRef.current?.reset();
        }
    }));

    const handleSuccess = (token) => {
        if (onVerify) onVerify(token);
    };

    const handleError = () => {
        if (onVerify) onVerify(null);
        turnstileRef.current?.reset();
    };

    const handleExpire = () => {
        if (onVerify) onVerify(null);
        turnstileRef.current?.reset();
    };

    return (
        <div className="w-full flex justify-center my-4">
            <Turnstile
                ref={turnstileRef}
                siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY}
                onSuccess={handleSuccess}
                onError={handleError}
                onExpire={handleExpire}
                options={{
                    theme: 'light',
                    size: 'flexible',
                    refreshExpired: 'auto',
                    appearance: 'interaction-only',
                    language: i18n.language
                }}
            />
        </div>
    );
});

Captcha.displayName = "Captcha";